// extracted by mini-css-extract-plugin
export default {"emailContainer":"emailList_emailContainer__c05f8","cancelBtn":"emailList_cancelBtn__3ERKS"};